import Api from '@/api/Api'
import store from '../store'

export default {
  async getMonthlyUsed (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}`))
  },
  async getMonthlyUsedCreditRecordList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/records`))
  },
  async getMonthlyUsedCreditFileList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/files`))
  },
  async getMonthlyUsedCreditLineMessageList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/messages/line`))
  },
  async getMonthlyUsedCreditEmailList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/emails`))
  },
  async getMonthlyUsedCreditQRCodeList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/qrcodes`))
  },
  async getMonthlyUsedCreditBranchList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/branches`))
  },
  async getMonthlyUsedCreditWarehouseList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/warehouses`))
  },
  async getMonthlyUsedCreditUserList (date) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/users`))
  },
  async getMonthlyUsedCreditAppList (date, params) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/monthly/${date}/credit/apps`, { params }))
  },
  async getInvoiceList (params) {
    return store.dispatch('checkResponseApi', await Api().get('useability/invoices', { params }))
  },
  async getInvoiceSingle (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}`))
  },
  async getInvoiceCreditRecordList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/records`))
  },
  async getInvoiceCreditFileList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/files`))
  },
  async getInvoiceCreditLineMessageList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/messages/line`))
  },
  async getInvoiceCreditEmailList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/emails`))
  },
  async getInvoiceCreditQRCodeList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/qrcodes`))
  },
  async getInvoiceCreditBranchList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/branches`))
  },
  async getInvoiceCreditWarehouseList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/warehouses`))
  },
  async getInvoiceCreditUserList (id) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/users`))
  },
  async getInvoiceCreditAppList (id, params) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/invoices/${id}/credit/apps`, { params }))
  },
  async getBillSingleByCode (code) {
    return store.dispatch('checkResponseApi', await Api().get(`useability/bills/code/${code}`))
  },
  async getTransactionList (params) {
    return store.dispatch('checkResponseApi', await Api().get('useability/transactions', { params }))
  },
}



// WEBPACK FOOTER //
// ./src/api/UseabilityService.js